export interface ITreeExpandable {
  expandTree(): void;
}

export function instanceOfITreeExpandable(instance: any): instance is ITreeExpandable {
  if (!instance) { return false; }
  return (instance.expandTree !== undefined);
}
